module.exports = __webpack_public_path__ + "imgs/default-profile-icon.c4a25f9bf02a9fe70fb27027f97e633e.jpg";